import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../../shared/components/Modal';
import Spinner from 'react-bootstrap/Spinner';
import PartialCreditNoteTable from './PartialCreditNoteTable';
import PartialCreditNoteTableActions from './PartialCreditNoteTableActions';

const PartialCreditNote = ({ closeModal, opened, id_factura_t, num_fac_ter, providerFE = null, closeModalFinish }) => {

    const [invoiceDataPatients, setInvoiceDataPatients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingProcess, setLoadingProcess] = useState(false);
    const [colorAlertModal, setColorAlertModal] = useState("");
    const [messageAlertModal, setMessageAlertModal] = useState("");
    const [showAlertModal, setShowAlertModal] = useState(false);

    useEffect(() => {
        getPatientsFromInvoice();
    }, []);

    const getPatientsFromInvoice = async () => {
        setLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}facturas/listar-recibos-factura?id_factura_t=${id_factura_t}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((dataPatients) => {
            let arrPatients = filterData(dataPatients);
            setInvoiceDataPatients(arrPatients);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
        });
    }

    const filterData = (dataPatients) => {
        for (let i = 0; i < dataPatients.length; i++) {
            dataPatients[i].seleccionado = false;
        }
        return dataPatients;
    }

    const selectPatients = (patient, value) => {
        let dataNew = invoiceDataPatients.slice();
        let index = dataNew.findIndex(pat => pat.id_recibo == patient.id_recibo);
        dataNew[index].seleccionado = value;
        setInvoiceDataPatients(dataNew);
    }

    const generateCreditNote = async () => {
        setLoadingProcess(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notacredito/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura_t,
                recibos_caja: mappingReceiptsPatients()
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((data) => {
            setLoadingProcess(false);
            setMessageAlertModal("La nota Credito se ha Generado Correctamente");
            setColorAlertModal("success");
            setShowAlertModal(true);
        }).catch(err => {
            setLoadingProcess(false);
            setMessageAlertModal("Ha ocurrido un error en el servidor");
            setColorAlertModal("danger");
            setShowAlertModal(true);
            console.log(err);
        });
    }

    const generateCreditNoteiFacturaApp = async () => {
        setLoadingProcess(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notacredito/create-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura_t,
                recibos_caja: mappingReceiptsPatients()
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((data) => {
            setLoadingProcess(false);
            setMessageAlertModal("La nota Credito se ha Generado Correctamente");
            setColorAlertModal("success");
            setShowAlertModal(true);
        }).catch(err => {
            setLoadingProcess(false);
            setMessageAlertModal("Ha ocurrido un error en el servidor");
            setColorAlertModal("danger");
            setShowAlertModal(true);
            console.log(err);
        });
    }

    const preGenerateCreditNote = async () => {
        switch (parseInt(providerFE.id_factura_electronica_api)) {
            case 2: //Talumm
            generateCreditNote();
            break;
            case 3: //iFacturaApp
            generateCreditNoteiFacturaApp();
            break;
        }}

    const mappingReceiptsPatients = () => {
        let dataPatientsReceipt = [];
        invoiceDataPatients.map((item, index) => {
            if(item.seleccionado == true)
            {
                dataPatientsReceipt.push(item.id_recibo);
            }
        });
        return dataPatientsReceipt;
    }

    const onOkModal = () => {
        setShowAlertModal(false);
        if (colorAlertModal == "success") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            closeModalFinish();
        }
        else if (colorAlertModal == "warning") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            preGenerateCreditNote();
        }
        else {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
    }

    const onToggleModal = () => {
        setShowAlertModal(false);
        if (colorAlertModal == "success") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            closeModal();
        }
        else if (colorAlertModal == "warning") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
        else {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Gestión de Nota Crédito Parcial</h5>
                            <br />
                            <h6 className="bold-text">Factura: {num_fac_ter}</h6>
                        </div>
                        <br />
                    </div>

                    <div>
                        {loading ? <div className="text-center">
                            <Spinner animation="border" variant="success" />
                        </div> :
                            <PartialCreditNoteTable
                                reactTableData={invoiceDataPatients}
                                ReactTableActions={PartialCreditNoteTableActions}
                                selectPatients={selectPatients}
                            />}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                        {loadingProcess == true ? <Spinner animation="border" variant="success" /> : <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setShowAlertModal(true);
                                setMessageAlertModal("Esta completamente seguro de Generar la Nota Crédito");
                                setColorAlertModal("warning");
                            }}
                        >
                            Generar Nota Crédito
                        </Button>}

                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            {
                <AlertModal
                    color={colorAlertModal}
                    title={messageAlertModal}
                    modal={showAlertModal}
                    onOk={() => onOkModal()}
                    toggle={() => onToggleModal()}
                />}
        </div>
    );
};
export default PartialCreditNote;
